import { useTranslation } from 'react-i18next';
import './WriteOffAllDayTable.css';

export const WriteOffAllDayTable = ({ records }) => {
    const { t } = useTranslation('warehouse');

    return (
        <div className={'write-off-table-container'}>
            <table>
                <thead>
                <tr>
                    <th className={'td'}>{t('productName')}</th>
                    <th className={'td'}>{t('invoice')}</th>
                    <th className={'td'}>{t('invoiceDate')}</th>
                    <th className={'td'}>{t('amount')}</th>
                    <th className={'td'}>{t('writeOff')}</th>
                </tr>
                </thead>
                <tbody>
                {records == null || records.length === 0 ? <></> : records.map((record, index) => {
                    return (
                        <tr key={index}>
                            <td className={'td'}>{record.productName}</td>
                            <td className={'td'}>{record.invoice}</td>
                            <td className={'td'}>{record.invoiceDate}</td>
                            <td className={'td'}>{record.amount}</td>
                            <td className={'td input-cell'}>
                                <input type={'number'}
                                       className={'form-control'}
                                       id={'writeOffAmount-' + index}
                                       defaultValue={record.writeOffAmount}
                                       onChange={(event) => record.writeOffAmount = +event.target.value} />
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
};